import { gql } from '@edreamsodigeo/frontend-api-client';

export const CREATE_SHOPPING_BUNDLE = gql`
  mutation CreateShoppingBundle($request: CreateShoppingBundleRequest!)
  @update_groups(groups: "shoppingBundle") {
    createShoppingBundle(request: $request) {
      shoppingBundle {
        shoppingId
      }
    }
  }
`;
